import i18next from 'i18next';

i18next.addResources('es', 'technicalSheet', {
  general: 'General',
  countries: 'Países',
  area: 'Ámbito',
  subsector: 'Subsector',
  stateOfProject: 'Estado del proyecto',
  status: 'Etapa',
  estimatedEndDate: 'Fin estimado',
  ambientalLicense: 'Licencia ambiental',
  finance: 'Costo y financiamiento',
  totalInvestment: 'Inversión total',
  financing: 'Tipo',
  sources: 'Fuentes',
  responsableOfInformation: 'Responsables de información',
  name: 'Nombre',
  role: 'Cargo',
  email: 'e-mail',
  institution: 'Fuente',
  technicalSheet: 'Ficha Técnica',
  range: 'Alcance',
  objectives: 'Objetivos',
  description: 'Descripción',
  url: 'Enlace',
  info: 'info',
  yes: 'Si',
  no: 'No',
  public_project: 'Público', // eslint-disable-line camelcase
  private_project: 'Privado', // eslint-disable-line camelcase
  mixed_project: 'Mixto', // eslint-disable-line camelcase
  amount: 'Monto',
  firstName: 'Nombre',
  lastName: 'Apellido',
  documents: 'Documentos',
  relatedProjects: 'Proyectos relacionados',
  phone: 'Teléfono',
  ilat: 'ILAT',
  comments: 'Comentarios',
  sections: 'Tramos',
  complementaryInfo: 'Información complementaria',
  state: 'Estado',
  studies: 'Estudios',
  links: 'Enlaces',
  type: 'Tipo',
  source: 'Fuente',
  sector: 'Sector',
  acción: 'Acción',
  etapa: 'Etapa',
  'estado de estudios': 'Estado de estudios',
  'monto de estudios': 'Monto de estudios',
  'estudios finalizados': 'Estudios finalizados',
  'fecha finalización': 'Fecha de finalización',
  'priorización': 'Priorización',
  projectSheet: 'Ficha de proyecto'
});

i18next.addResources('en', 'technicalSheet', {
  general: 'General',
  countries: 'Countries',
  area: 'Area',
  subsector: 'Subsector',
  stateOfProject: 'Project status',
  status: 'Stage',
  estimatedEndDate: 'Estimated end',
  ambientalLicense: 'Environmental license',
  finance: 'Cost and financing',
  totalInvestment: 'Total investment',
  financing: 'Type',
  sources: 'Sources',
  responsableOfInformation: 'Information managers',
  name: 'Name',
  role: 'Position',
  email: 'e-mail',
  institution: 'Source',
  technicalSheet: 'Technical Sheet',
  range: 'Scope',
  objectives: 'Objectives',
  description: 'Description',
  url: 'Link',
  info: 'info',
  yes: 'Yes',
  no: 'No',
  public_project: 'Public', // eslint-disable-line camelcase
  private_project: 'Private', // eslint-disable-line camelcase
  mixed_project: 'Mixed', // eslint-disable-line camelcase
  amount: 'Amount',
  firstName: 'First name',
  lastName: 'Last name',
  documents: 'Documents',
  relatedProjects: 'Related projects',
  phone: 'Phone',
  ilat: 'ILAT',
  comments: 'Comments',
  sections: 'Sections',
  complementaryInfo: 'Complementary information',
  state: 'State',
  studies: 'Studies',
  links: 'Links',
  type: 'Type',
  source: 'Source',
  sector: 'Sector',
  acción: 'Action',
  etapa: 'Stage',
  'estado de estudios': 'Studies status',
  'monto de estudios': 'Studies amount',
  'estudios finalizados': 'Studies completed',
  'fecha finalización': 'End date',
  'priorización': 'Prioritization',
  projectSheet: 'Project sheet'
});

i18next.addResources('pt', 'technicalSheet', {
  general: 'Geral',
  countries: 'Países',
  area: 'Âmbito',
  subsector: 'Subsetor',
  stateOfProject: 'Estado do projeto',
  status: 'Etapa',
  estimatedEndDate: 'Fim estimado',
  ambientalLicense: 'Licença ambiental',
  finance: 'Custo e financiamento',
  totalInvestment: 'Investimento total',
  financing: 'Tipo',
  sources: 'Fontes',
  responsableOfInformation: 'Responsáveis pela informação',
  name: 'Nome',
  role: 'Cargo',
  email: 'e-mail',
  institution: 'Fonte',
  technicalSheet: 'Ficha Técnica',
  range: 'Alcance',
  objectives: 'Objetivos',
  description: 'Descrição',
  url: 'Link',
  info: 'info',
  yes: 'Sim',
  no: 'Não',
  public_project: 'Público', // eslint-disable-line camelcase
  private_project: 'Privado', // eslint-disable-line camelcase
  mixed_project: 'Misto', // eslint-disable-line camelcase
  amount: 'Valor',
  firstName: 'Nome',
  lastName: 'Sobrenome',
  documents: 'Documentos',
  relatedProjects: 'Projetos relacionados',
  phone: 'Telefone',
  ilat: 'ILAT',
  comments: 'Comentários',
  sections: 'Trechos',
  complementaryInfo: 'Informação complementar',
  state: 'Estado',
  studies: 'Estudos',
  links: 'Links',
  type: 'Tipo',
  source: 'Fonte',
  sector: 'Setor',
  acción: 'Ação',
  etapa: 'Etapa',
  'estado de estudios': 'Estado dos estudos',
  'monto de estudios': 'Valor dos estudos',
  'estudios finalizados': 'Estudos concluídos',
  'fecha finalización': 'Data de conclusão',
  'priorización': 'Priorização',
  projectSheet: 'Ficha do projeto'
});
